import moment from "moment";
import { convertHoursToInt } from "./dateHourUtils";

export const isForTodayOrTomorrow = outboundDate => {
	const todayDay = moment(new Date()).format("DD/MM/YYYY");
	const tomorrowDay = moment(new Date())
		.add(1, "days")
		.format("DD/MM/YYYY");
	const outboundDateDay = moment(outboundDate).format("DD/MM/YYYY");
	return tomorrowDay === outboundDateDay || todayDay === outboundDateDay;
};

/**
 * Mostra a qual período do dia um voo pertence
 * @param {String} departureDate
 * @returns {String}
 */
export const getDepartureString = departureDate => {
	const time = convertHoursToInt(departureDate);

	const departureRuleDawn = dayTime => dayTime >= 0 && dayTime <= 559;
	const departureRuleMorning = dayTime => dayTime >= 600 && dayTime <= 1159;
	const departureRuleAfternoon = dayTime => dayTime >= 1200 && dayTime <= 1759;
	const departureRuleNight = dayTime => dayTime >= 1800 && dayTime <= 2359;

	if (departureRuleDawn(time)) return "madrugada";

	if (departureRuleMorning(time)) return "manha";

	if (departureRuleAfternoon(time)) return "tarde";

	if (departureRuleNight(time)) return "noite";
};

export const feesTranslations = {
	BOARDING_TAX: "Taxa de embarque e encargos",
	CONVENIENCE_FEE: "Taxas de conveniência",
	SERVICE_FEE: "Taxa de emissão",
	LUGGAGE_FEE: "Bagagem",
	AIRLINE_SURCHARGE: "Sobretaxas e outros encargos",
	boardingFee: "Taxa de embarque e encargos",
	convenienceFee: "Taxas de conveniência",
	serviceFee: "Taxa de serviço",
	luggageFee: "Bagagem"
};

export const copyToClipboard = textToCopy => {
	if (navigator.clipboard && window.isSecureContext) {
		return navigator.clipboard.writeText(textToCopy);
	} else {
		let textArea = document.createElement("textarea");
		textArea.value = textToCopy;
		textArea.style.position = "fixed";
		textArea.style.left = "-999999px";
		textArea.style.top = "-999999px";
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
		return new Promise((resolve, reject) => {
			document.execCommand("copy") ? resolve() : reject();
			textArea.remove();
		});
	}
};

export const mountSearchUrl = params => {
	const items = [
		params.tripType,
		params.from.iata,
		params.to.iata,
		params.outboundDate || params.departure
	];
	if (params.tripType === "RT") {
		items.push(params.inboundDate || params.arrival);
	}
	items.push(params.adults, params.children, params.infants, params.cabin);
	return `/busca-passagens-aereas/${items.join("/")}`;
};

export const mountSearchUrlFromActiveCheckout = search => {
	const items = [search.tripType, search.from, search.to, search.outboundDate];
	if (search.tripType === "RT") {
		items.push(search.inboundDate);
	}
	items.push(search.adults, search.children, search.infants, search.cabin);
	return `/busca-passagens-aereas/${items.join("/")}`;
};

export const isOTA = activeCheckout => {
	let ota = activeCheckout.outboundFlight.pricing === "ota";
	if (activeCheckout.search.tripType === "RT") {
		ota = ota || activeCheckout.inboundFlight.pricing === "ota";
	}
	return ota;
};
